// validation patterns
export const emailRegexString = /(\s){0,}[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~]+@[a-zA-Z0-9](?:[a-zA-Z0-9]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9]{0,61}[a-zA-Z0-9])?){1,}(\s){0,}/;
export const phoneRegexString = /\+?[1-9]\d{4,14}/;
export const nameRegexString = /^[a-zA-Z0-9\s-]*$/; // This will match a wide variety of names including unicode
export const zipCodeRegexString = /^\d{5}(?:[-\s]\d{4})?$/;
export const postalCodeRegexString = /^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJKLMNPRSTVWXYZ][ -]?\d[ABCEGHJKLMNPRSTVWXYZ]\d$/i;
export const zipOrPostalCodeRegexString = /^(?:\d{5}(?:[-\s]\d{4})?|[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJKLMNPRSTVWXYZ][ -]?\d[ABCEGHJKLMNPRSTVWXYZ]\d)$/i;
